module.exports = __webpack_public_path__ + "static/img/3.4d89e1a4.png";